<template>
  <CtiOpenButton
    :tooltip-message="$t('callTarget.header.miitel')"
    :disabled="disable"
    @click="handleClick"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';
import CtiOpenButton from './CtiOpenButton.vue';

export default defineComponent({
  components: {
    CtiOpenButton,
  },
  computed: {
    ...mapGetters('userUi', [
      'miitelWidgetVisible',
    ]),
    disable () {
      return this.miitelWidgetVisible;
    },
  },
  methods: {
    ...mapWaitingActions('userUi', {
      setMiitelWidgetVisibleAction: 'setMiitelWidgetVisibleWait',
    }),
    handleClick () {
      this.setMiitelWidgetVisibleAction(true);
    },
  },
});
</script>
